import { Link } from "react-router-dom";
import ModalWrapper from "./Modal";
import styles from "./Modal.module.css";

function ViewMediaModal({ isVisible, handleClose, url, mediaType, title }) {
  return (
    <ModalWrapper isVisible={isVisible} name="view_media_modal" level={3} fit onClose={handleClose}>
      <div className="section_wrapper">
        <div className="section_title_wrapper">
          <h3 className="section_title">{title}</h3>
        </div>
        <div className="column">
          <div className={url.length > 1 ? (url.length < 5 ? "row" : styles.image_grid_multi) : styles.image_grid}>
            {mediaType === "videos" || mediaType === "video" ? (
              <video controls className="">
                <source src={url[0]} type="video/webm" />
                <source src={url[0]} type="video/mp4" />
              </video>
            ) : (
              url.map((image, index) => (
                <Link to={image} target="_blank" key={index}>
                  <img src={image} alt="" key={index} className={styles.uploaded_image} />
                </Link>
              ))
            )}
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
}

export default ViewMediaModal;
